import { render, staticRenderFns } from "./PicaServiceRedirect.vue?vue&type=template&id=4d2a549e&"
import script from "./PicaServiceRedirect.vue?vue&type=script&lang=js&"
export * from "./PicaServiceRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports